/* eslint-disable import/no-cycle */
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import common from "./modules/common";
import courses from "./modules/courses";
import dashboard from "./modules/dashboard";
import assessments from "./modules/assessments";
import reports from "./modules/reports";
import telasAdmin from "./modules/telas-admin";
import frameworks from "./modules/frameworks";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    user,
    common,
    courses,
    dashboard,
    assessments,
    reports,
    telasAdmin,
    frameworks,
  },
  strict: debug,
});
export default store;
